const USER_INFO_KEY = "webphone";
const IAM_INFO_KEY = "userInfo";

const getStorageParams = (value: any) => {
  let params = null;
  if (!value) return params;
  try {
    params = JSON.parse(value);
  } catch (e) {
    params = value;
  }
  return params;
};

const getUserInfoStorage = () => getStorageParams(localStorage.getItem(USER_INFO_KEY));
const getUserIamInfoStorage = () => getStorageParams(localStorage.getItem(IAM_INFO_KEY));
declare global {
  interface Window {
    sensorsDataAnalytic201505?: any;
  }
}

/** 神策埋点数据接收端，与 F2E-harbour-web 共用同一接收服务 */
const SENSORS_SERVER_URL = `${location.origin}/api/system-alert-ticket-server/frontend/logs`;

let initialized = false;

export type SensorsEventType = "点击" | "搜索" | "查询" | "提交" | "异常";

export const trackCustomEvent = (
  eventDesc: string,
  featureName: string,
  eventType: SensorsEventType = "提交",
  extraProps?: Record<string, any>,
) => {
  const sensors = window.sensorsDataAnalytic201505;
  if (!sensors || typeof sensors.track !== "function") return;

  try {
    sensors.track("自定义事件", {
      event_type: eventType,
      event_desc: eventDesc,
      ...extraProps,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`[sensors] ${featureName}埋点上报失败`, error);
  }
};

/**
 * 获取当前页面名称：取无界中台顶栏当前激活 tab 的文本
 * 子应用运行在无界微前端下，激活 tab 位于主应用（父应用）document 中
 * 取不到值（无激活 tab / 跨域报错）时兜底为「工作台」
 */
const getCurrentPageName = (): string => {
  try {
    const doc = document;
    const activeTab = doc.querySelector<HTMLElement>(
      ".yzs-tabs-container .ant-tabs-tab.ant-tabs-tab-active",
    );
    return activeTab?.textContent?.trim() || "工作台";
  } catch {
    return "工作台";
  }
};

/**
 * 初始化神策埋点 SDK
 * 对齐 F2E-harbour-web 的接入方式：单页采集 + ajax 携带 token + 点击图
 * 与 F2E 的差异：本项目无 window.esapp，用户信息改从 localStorage.userInfo 读取
 */
export const initSensors = () => {
  if (initialized) return;
  const sensors = window.sensorsDataAnalytic201505;
  if (!sensors) {
    // eslint-disable-next-line no-console
    console.warn("[sensors] sensorsdata.min.js 未加载，跳过埋点初始化");
    return;
  }

  const userInfo: any = getUserInfoStorage() || {};
  const userIamInfo: any = getUserIamInfoStorage() || {};
  sensors.init({
    server_url: SENSORS_SERVER_URL,
    is_track_single_page: true, // 单页面配置：URL 变化自动触发 $pageview
    use_client_time: true,
    send_type: "beacon", //  content-type:text/plain
    // beacon 模式不支持自定义请求头，切到 ajax 才能把 token 带到埋点请求 Header 里
    // send_type: 'ajax',
    // header: token ? { Authorization: token } : undefined,
    heatmap: {
      clickmap: "default", // 开启点击图，自动采集 $WebClick
      scroll_notice_map: "not_collect", // 关闭触达图
    },
  });

  // 用户关联（IDM 2.0）：把真实用户 ID 关联到神策 distinct_id，
  // 必须在 quick('autoTrack') 之前调用，确保首个 $pageview 就带上 login_id。
  // login_id 要求字符串，神策会自动触发 $SignUp 并把登录前后行为串联。
  if (userIamInfo.huid) {
    sensors.login(String(userIamInfo.huid));
  }

  sensors.quick("autoTrack");
  sensors.registerPage({
    platform_type: "鸭嘴兽中台",
    user_name: userInfo?.userDisplayName,
    group: userInfo?.dispatcherGroup,
    service_name: "harbour-portal-pc",
    service_version: __APP_VERSION__,
    // 动态公共属性：传函数引用，神策会在每次事件触发时调用，取最新激活 tab 名称
    page_name: getCurrentPageName,
  });

  initialized = true;
};
